// regex taken from svelte/compiler
// https://github.com/sveltejs/svelte/blob/dd9abea2a1059cbead398c5578bfd07a3c3ddd69/packages/svelte/src/compiler/preprocess/index.js#L253

const HAS_SCRIPT_RE =
  /<script((?:\s+[^=>'"/\s]+=(?:"[^"]*"|'[^']*'|[^>\s]+)|\s+[^=>'"/\s]+)*\s*)>([\S\s]*?)<\/script>/g;

export const isSourceScripted = (source: string) => {
  // let's always force a reload if it contains a script tag
  return HAS_SCRIPT_RE.test(source);
};
